import Vue from "vue";

const host = window.location.hostname;
var pathApi = "";
var pathAPiControl = "";
var pathApiNew = "";

if (host === "localhost") {
  // local
  pathApi = process.env.VUE_APP_API_LOCAL;
  pathAPiControl = process.env.VUE_APP_API_LOCAL_CONTROL;
  pathApiNew = process.env.VUE_APP_API_LOCAL_NEW;
} else if (host === "test-newpartner.merudy.com") {
  // rudy test
  pathApi = process.env.VUE_APP_API_RUDY_TEST;
  pathAPiControl = process.env.VUE_APP_API_RUDT_TEST_CONTROL;
  pathApiNew = process.env.VUE_APP_API_RUDY_TEST_NEW;
} else if (host === "newpartner.merudy.com") {
  // rudy prd
  pathApi = process.env.VUE_APP_API_RUDY_PROD;
  pathAPiControl = process.env.VUE_APP_API_RUDY_PROD_CONTROL;
  pathApiNew = process.env.VUE_APP_API_RUDY_PROD_NEW;
} else if (host === "test-newpartner.nexterdigitals-dev.com") {
  // scg test
  pathApi = process.env.VUE_APP_API_SCG_TEST;
  pathAPiControl = process.env.VUE_APP_API_SCG_TEST_CONTROL;
  pathApiNew = process.env.VUE_APP_API_SCG_TEST_NEW;
} else if (host === "newpartner.scg.com") {
  // scg prd
  pathApi = process.env.VUE_APP_API_SCG_PROD;
  pathAPiControl = process.env.VUE_APP_API_SCG_PROD_CONTROL;
  pathApiNew = process.env.VUE_APP_API_SCG_PROD_NEW;
} else {
  // local
  pathApi = process.env.VUE_APP_API_LOCAL;
  pathAPiControl = process.env.VUE_APP_API_LOCAL_CONTROL;
  pathApiNew = process.env.VUE_APP_API_LOCAL_NEW;
}

const baseAPI = pathApi;
const baseAPIControl = pathAPiControl;
const baseAPINew = pathApiNew;

Vue.prototype.$baseAPI = baseAPI;
Vue.prototype.$baseAPIControl = baseAPIControl;
Vue.prototype.$baseAPINew = baseAPINew;

window.baseAPI = baseAPI;
window.baseAPIControl = baseAPIControl;
window.baseAPINew = baseAPINew;

export default {};
